<template>
  <div>
    <router-link
      :to="{ name: 'admin.academy.videos.create' }"
      class="btn btn-info btn-sm float-right"
      >Add Video</router-link
    >
    <h5>Videos</h5>
    <div class="row" v-if="!loading">
      <div class="col-md-4" v-for="(video, i) in videos" :key="`video-${i}`">
        <div class="card">
          <router-link
            :to="{
              name: 'admin.academy.videos.show',
              params: { video_id: video.id },
            }"
          >
            <video-thumbnail :video="video" />
          </router-link>
          <div class="px-2 my-2">
            <router-link
              :to="{
                name: 'admin.academy.videos.show',
                params: { video_id: video.id },
              }"
              >#{{ video.sort }} {{ video.title }}</router-link
            >
            <div class="mt-2">
              <router-link :to="{ name: 'admin.academy.videos.edit', params: { video_id: video.id }}" class="btn btn-info btn-sm"><i class="lni lni-pencil"></i></router-link>
              <a href="#" @click.prevent="destroy(video.id)" class="btn btn-danger btn-sm float-right"><i class="lni lni-trash-can"></i></a>
            </div>
          </div>
        </div>
      </div>
      <div class="col-12" v-if="videos.length == 0">
        <div class="alert alert-warning">There is no data to display</div>
      </div>
    </div>
    <loading v-if="loading" />
  </div>
</template>

<script>
export default {
  mounted() {
    this.fetch();
  },

  data() {
    return {
      loading: true,
      videos: [],
    };
  },

  methods: {
    fetch() {
      this.loading = true;

      this.$axios
        .get(`/api/v1/admin/academy/${this.$route.params.week_id}/videos`)
        .then((response) => {
          this.videos = response.data.videos;
          this.loading = false;
        });
    },

    destroy(video_id) {
      this.loading = true

      this.$axios
        .delete(`/api/v1/admin/academy/${this.$route.params.week_id}/videos/${video_id}`)
        .then(() => {
          this.fetch()
        });
    }
  },
};
</script>
